var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7008 12.6277C26.6157 11.6755 25.1148 10.2215 23.8923 9.19025L23.82 9.14213C23.6996 9.05027 23.5639 8.97823 23.4185 8.929C20.4708 8.40651 6.75229 5.96935 6.48465 6.00029C6.40966 6.01027 6.33797 6.03612 6.27488 6.07592L6.20616 6.12748C6.12154 6.20915 6.05727 6.30782 6.01808 6.41622L6 6.46091V6.70497V6.74278C7.54437 10.8299 13.6423 24.2188 14.8431 27.3606C14.9154 27.5738 15.0528 27.9794 15.3096 28H15.3675C15.5049 28 16.0909 27.2644 16.0909 27.2644C16.0909 27.2644 26.5651 15.192 27.6248 13.9064C27.762 13.7481 27.8831 13.5777 27.9865 13.3977C28.0129 13.2568 28.0004 13.1119 27.9504 12.9769C27.9003 12.842 27.8143 12.7217 27.7008 12.6277ZM18.7781 14.0336L23.2485 10.5102L25.8707 12.8065L18.7781 14.0336ZM17.0421 13.8033L9.34554 7.80839L21.7982 9.99118L17.0421 13.8033ZM17.7365 15.3742L25.6139 14.1677L16.6081 24.48L17.7365 15.3742ZM8.30028 8.40651L16.3983 14.9377L15.2264 24.4869L8.30028 8.40651Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrx);
export default __webpack_public_path__ + "static/media/TRX.5e472c776466d5c3e84bf2f92234f406.svg";
export { ForwardRef as ReactComponent };